import { Controller } from '@hotwired/stimulus'
import { useClickOutside } from 'stimulus-use'
import { enter, leave } from 'el-transition'
import hotkeys from 'hotkeys-js'

export default class extends Controller {
  static targets = [
    'loadingPlaceholder',
    'modal',
    'modalContainer',
    'turboFrame',
  ]

  connect() {
    useClickOutside(this, { element: this.modalTarget })
    hotkeys(
      'escape',
      { scope: this.element.id || 'clients--modal' },
      () => { this.hide() },
    )
  }

  clickOutside() {
    this.hide()
  }

  handleTurboBeforeFetchRequest(event) {
    if (event.detail.fetchOptions.method === 'GET') {
      this.show()
    }
  }

  handleTurboFrameLoad() {
    leave(this.loadingPlaceholderTarget)
    enter(this.turboFrameTarget)
  }

  handleTurboSubmitEnd(event) {
    if (event.detail.success) {
      this.hide()
    }
  }

  hide() {
    hotkeys.setScope('all')
    leave(this.modalContainerTarget)
    document.querySelector('body').classList.remove('overflow-hidden')
  }

  show() {
    hotkeys.setScope(this.element.id || 'clients--modal')
    enter(this.loadingPlaceholderTarget)
    leave(this.turboFrameTarget)
    enter(this.modalContainerTarget)
    document.querySelector('body').classList.add('overflow-hidden')
  }
}
